import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "ViolationListPage" */
	'pages/vehicle/Violation/ViolationListPage'));

export default [{ component, exact: true, path: '/violations' }];